import React, { Component } from 'react';

class Etapa4 extends Component {

    state = {
        avaliacaoEspacoFisico: '',
        selecionado: false
    }
    
    componentWillMount(){
        this.setState({
            medico: this.props.location.state.medico,
            avaliacaoRecepcao: this.props.location.state.avaliacaoRecepcao,
            avaliacaoMedico: this.props.location.state.avaliacaoMedico
        })
    }

    render() {
        return (
            <div>
                <center>
                    <h1 style={{marginTop:'8%'}}>Qual sua avaliação da parte <strong>física</strong> <br /> da clínica? </h1>
                </center>

                <div className="container">
                
                    <div className="row d-flex justify-content-center" style={{marginTop:'5%'}}>
                        <div className="rating">
                            <input type="radio" id="star5" name="rating" value="5" onChange={() => this.setState({avaliacaoEspacoFisico: 5, selecionado: true})}/><label htmlFor="star5" title="Ruim"></label>
                            <input type="radio" id="star4" name="rating" value="4" onChange={() => this.setState({avaliacaoEspacoFisico: 4, selecionado: true})}/><label htmlFor="star4" title="Ruim"></label>
                            <input type="radio" id="star3" name="rating" value="3" onChange={() => this.setState({avaliacaoEspacoFisico: 3, selecionado: true})}/><label htmlFor="star3" title="Regular"></label>
                            <input type="radio" id="star2" name="rating" value="2" onChange={() => this.setState({avaliacaoEspacoFisico: 2, selecionado: true})}/><label htmlFor="star2" title="Bom"></label>
                            <input type="radio" id="star1" name="rating" value="1" onChange={() => this.setState({avaliacaoEspacoFisico: 1, selecionado: true})}/><label htmlFor="star1" title="Ótimo"></label>
                        </div>
                    </div>
                    <br /><br/>
                    <center>
                        {this.state.selecionado &&
                            <button type="submit" className="btn btn-block btn-home btn-success" onClick={() => {
                                    this.props.history.push({pathname:`/5`, state:this.state})
                                }}>Próximo</button>
                        }
                    </center>

                </div>
            </div>
        );
    }
}

export default Etapa4;